module.exports = __webpack_public_path__ + "assets/img/teacher (54).3405d183.png";